export const FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES = 'FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES';
export const FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_SUCCESS = 'FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_SUCCESS';
export const FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_FAILURE = 'FETCH_SL_ACCOUNTS_FOR_ACCOUNT_BALANCES_FAILURE';
export const SELECT_SL_ACCOUNTS = 'SELECT_SL_ACCOUNTS';

export const FETCH_ACCOUNT_BALANCES = 'FETCH_ACCOUNT_BALANCES';
export const FETCH_ACCOUNT_BALANCES_SUCCESS = 'FETCH_ACCOUNT_BALANCES_SUCCESS';
export const FETCH_ACCOUNT_BALANCES_FAILURE = 'FETCH_ACCOUNT_BALANCES_FAILURE';
